import React from 'react';
import OffsiderWebsite from './OffsiderWebsite';

function App() {
  return <OffsiderWebsite />;
}

export default App;
